module.exports = __webpack_public_path__ + "img/India.d9bf0611.svg";